import Breadcrumb from '../components/Breadcrumb';
import ExecutiveDevices from './components/TitleSubjects/ExecutiveDevices.js';

const TitlesSubjectCodes = () => {
  return (
    <>
      <Breadcrumb pageName="عناوین کدهای موضوعی" />
      <ExecutiveDevices />
    </>
  );
};

export default TitlesSubjectCodes;
